enum Language {
  En = 'en',
  Fr = 'fr',
}

export default Language
